export default "assets/images/logo-e0efe017.png";